const shouldShowMerchTab = ({
  hasMerchResource,
  eventProducts,
  hasMerchCollections,
}) => Boolean(
  hasMerchResource && (eventProducts?.length > 0 || hasMerchCollections)
);

export default shouldShowMerchTab;
